import fr from '../../../translations/messages.fr.json';
import en from '../../../translations/messages.en.json';

// Les traductions autres que le français sont à faire valider (voir "_note" dans chaque fichier).
const DICTS = { fr, en };
const DEFAULT_LANG = 'fr';

const get = (obj, path) => path.split('.').reduce((o, k) => (o == null ? o : o[k]), obj);

/**
 * Textes utilisés par le JavaScript (ex. messages de validation du formulaire).
 * Les textes de la page sont statiques : le français est servi à la racine, l'anglais sous /en/
 * (HTML généré au build par vite-plugins/localize-pages.js à partir des mêmes dictionnaires).
 * La langue courante est donc simplement celle du document.
 */
export const i18n = {
  get lang() {
    const lang = document.documentElement.lang;
    return lang in DICTS ? lang : DEFAULT_LANG;
  },

  t(key) {
    return get(DICTS[this.lang], key) ?? get(DICTS[DEFAULT_LANG], key) ?? key;
  },
};
